<template>
    <Dialog header="Create Training Folders" v-model:visible="model" modal style="width: 600px;" data-cy="training-folder-dialog">
        <FormField elementName="InputTags"
        v-model="emailList"
        label="Email addresses"
        dataField="training-email-list"
        ></FormField>
        <div class="flex gap-1 items-center justify-end ">
            <LoadingState v-if="loading" small />
            <Button icon="pi pi-plus" rounded label="Create" data-cy="training-create-folders-confirm" @click="createTrainingFolders" :disabled="emailList.length == 0 || loading"/>
        </div>
    </Dialog>
</template>
<script setup>
import { ref } from "vue";
const emailList = ref("");
import { useStore } from "vuex";
import {OP, usePending} from "@/src/queries/pending";

const model = defineModel({
    type: Boolean,
    required: true
})

const props = defineProps({
    workspaceId: { type: Number, required: true }
})

const loading = usePending(OP.CREATE_USERS_TRAINING_FOLDER)

const store = useStore();
const createTrainingFolders = async () => {
    await store.dispatch('repoStore/createUsersTrainingFolder', { workspaceId: props.workspaceId, emailList: emailList.value.split(',') })
    model.value = false
}
</script>